import React from 'react';
export const getSelectedLabelText = (children, selectedValue) => {
    const fullElement = children.find((child) => child.props.value === selectedValue);
    return fullElement ? fullElement.props.labelText : '--';
};
export const processChildren = (children, name, disabled, selectedValue, setSelectedValue, isScrollable) => {
    return React.Children.map(children, (child) => {
        return (React.createElement(child.type, { ...child, ...child.props, selectedValue: selectedValue, onClick: () => setSelectedValue(child.props.value), name: name, noBorder: isScrollable, disabled: disabled }));
    });
};
export const getDetailsEl = (id) => document.getElementById(id);
export const getSummaryEl = (id) => {
    const detailsEl = getDetailsEl(id);
    return detailsEl ? detailsEl.getElementsByTagName('summary')[0] : null;
};
export const getIsListOpen = (id) => {
    const detailsEl = getDetailsEl(id);
    return detailsEl ? detailsEl.hasAttribute('open') : false;
};
//# sourceMappingURL=index.js.map